import React, { useEffect } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { ComparisonSection } from './components/ComparisonSection';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { LeadForm } from './components/LeadForm';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initAntiInspect } from './utils/antiInspect';
import { initPixel, initAdvancedTracking } from './utils/pixel';
export function App() {
  useEffect(() => {
    initAntiInspect();
    initPixel();
    // Start advanced tracking after pixel is ready
    setTimeout(() => initAdvancedTracking(), 1000);
  }, []);
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-white" data-id="element-1">
        <Header data-id="element-2" />
        <main data-id="element-3">
          <HeroSection data-id="element-4" />
          <TrustBar data-id="element-5" />
          <ComparisonSection data-id="element-6" />
          <HowItWorks data-id="element-7" />
          <SocialProof data-id="element-8" />
          <LeadForm data-id="element-9" />
          <FinalCTA data-id="element-10" />
        </main>
        <Footer data-id="element-11" />
      </div>
    </LanguageProvider>;
}